import { Link } from "@bokio/elements/Link/Link";

import type { MouseEvent, ReactNode } from "react";

import * as styles from "./splitButton.scss";

export interface SplitButtonItemProps {
	testId?: string;
	onClick?: (e: MouseEvent<HTMLAnchorElement>, value: string) => void;
	value: string;
	route?: string;
	external?: string;
	children?: ReactNode;
}

export const SplitButtonItem = (props: SplitButtonItemProps) => {
	const onClick = (e: MouseEvent<HTMLAnchorElement>) => {
		if (props.onClick) {
			props.onClick(e, props.value);
		}
	};
	return (
		<Link
			testId={props.testId}
			style="none"
			onClick={onClick}
			className={styles.link}
			route={props.route}
			external={props.external}
		>
			{props.children}
		</Link>
	);
};
